import { observable } from "mobx";
import React from "react";
const viewModelCache = observable.map();
let reattaching = false;
const REATTACH_BLACKLIST = ["HXAutocompleteViewModel"];
export function useViewModel(viewModelClazz, argObject) {
    let construct;
    if (argObject !== undefined) {
        construct = () => new viewModelClazz(argObject);
    }
    else {
        construct = () => new viewModelClazz();
    }
    const viewModel = React.useState(() => {
        if (reattaching) {
            const cached = viewModelCache.get(viewModelClazz);
            if (cached && !REATTACH_BLACKLIST.includes(viewModelClazz.name)) {
                console.log("Re-attached ", viewModelClazz.name);
                return viewModelCache.get(viewModelClazz);
            }
        }
        const instance = construct();
        return instance;
    })[0];
    React.useEffect(() => {
        viewModelCache.set(viewModelClazz, viewModel);
        if (viewModel instanceof Object && "run" in viewModel && typeof viewModel.run === "function") {
            viewModel.run();
        }
        return () => {
            if (viewModel instanceof Object && "stop" in viewModel && typeof viewModel.stop === "function") {
                viewModel.stop();
            }
            viewModelCache.delete(viewModelClazz);
        };
    }, []);
    return viewModel;
}
export function getViewModel(viewModelClazz) {
    return viewModelCache.get(viewModelClazz);
}
export function getViewModels() {
    const obj = {};
    for (const [clazz, instance] of viewModelCache.entries()) {
        obj[clazz.name] = instance;
    }
    return obj;
}
export function activeViewModels() {
    return Array.from(viewModelCache.keys());
}
export function enableViewModelReattach() {
    reattaching = true;
}
export function disableViewModelReattach() {
    reattaching = false;
}
Object.defineProperty(window, "viewModels", {
    get: getViewModels,
    configurable: true,
    enumerable: true,
});
